import { render, staticRenderFns } from "./Imgfundo.vue?vue&type=template&id=ef72a678"
import script from "./Imgfundo.vue?vue&type=script&lang=js"
export * from "./Imgfundo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports